import { Language } from '@thiememeulenhoff/translations';
import { STORAGE_KEY_LANGUAGE } from '../constants/storage.constants';

export type BackendLanguage = Language.NL | Language.EN;

/**
 * Returns the UI language to send to the backend. Backend only accepts
 * `nl` / `en`; any other persisted value (or no value) falls back to NL
 * to match the dropdown's default.
 */
export const getCurrentLanguage = (): BackendLanguage => {
  const stored = localStorage.getItem(STORAGE_KEY_LANGUAGE);
  return stored === Language.EN ? Language.EN : Language.NL;
};
